import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { modules, levels, screens } from "../lessons";

export default function Dashboard() {
  const navigate = useNavigate();
  const [xp] = useState(() => Number(localStorage.getItem('sur_xp')) || 0);
  const [completed] = useState(() => JSON.parse(localStorage.getItem('sur_comp')) || []);
  
  const currentLevel = levels.reduce((acc, curr) => (xp >= curr.minXp ? curr : acc), levels[0]);

  return (
    <div className="surragne-root">
      <aside className="sidebar">
        <div className="brand">surragne</div>
        <div className="stats-box">
          <div className="stat">⭐ {xp} XP</div>
          <div className="stat">🏆 {currentLevel.name}</div>
        </div>
      </aside>
      <main className="viewport">
        <div className="skill-tree">
          {modules.map((mod, mIdx) => {
            const levelData = levels.find(l => l.id === mod.levelId);
            const isLocked = xp < levelData.minXp;
            return (
              <section key={mIdx} className={`module-section ${isLocked ? 'locked' : ''}`}>
                <h3>{mod.name} {isLocked && "🔒"}</h3>
                <div className="node-grid">
                  {screens.slice(mod.start, mod.end + 1).map((s, i) => {
                    const globalIdx = mod.start + i;
                    const isDone = completed.includes(globalIdx);
                    return (
                      <div key={globalIdx} className={`node ${isDone ? 'done' : ''}`} 
                           onClick={() => !isLocked && navigate(`/lesson/${globalIdx}`)}>
                        <div className="node-inner">{isDone ? "✓" : globalIdx + 1}</div>
                        <span>{s.title}</span>
                      </div>
                    );
                  })}
                </div>
              </section>
            );
          })}
        </div>
      </main>
    </div>
  );
}
